/**
 * Nuxt plugin for Commerce Layer integration.
 *
 * This plugin:
 * 1. Skips initialization for federated environments
 * 2. Fetches user session under specific rendering conditions
 * 3. Initializes Commerce Layer client
 *
 * @type {import('nuxt/app').NuxtPlugin}
 * @name nuxt:commerce-layer
 */
// @ts-ignore
export default defineNuxtPlugin(async nuxtApp => {
  // Skip initialization for federated environments
  if (useRuntimeConfig().public.isFederated) return

  /**
   * Fetch user session under specific conditions:
   * - Not server-rendered
   * - Pre-rendered
   * - Cached
   */
  if (!nuxtApp.payload.serverRendered) {
    await useUserSession().fetch()
  } else if (
    Boolean(nuxtApp.payload.prerenderedAt) ||
    Boolean(nuxtApp.payload.isCached)
  ) {
    await useUserSession().fetch()
  }

  /**
   * Initialize Commerce Layer client.
   * @type {Object} Commerce Layer client instance
   */
  const { cl } = await useCL()

  /**
   * Provide Commerce Layer client to the Nuxt application.
   * @returns {Object} Provides the Commerce Layer client
   */
  return {
    provide: {
      cl,
    },
  }
})
